import React from 'react';
import { Card, CardContent, Grid, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  primaryText: {
    paddingLeft: '5px',
    margin: '0',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '250px',
    whiteSpace: 'nowrap',
    display: 'block',
  },
  secondaryTextRed: {
    color: 'rgba(255, 0, 0, 1)',
  },
  cardContent: {
    marginRight: '10px',
    borderRadius: '8px',
    marginTop: '10px',
    marginBottom: '5px',
    cursor: 'pointer',
  },
  cardBottom: {
    marginTop: '14px',
    marginBottom: '-10px',
    display: 'flex',
    justifyContent: 'space-between',
    paddingLeft: '5px',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '15px',
    color: 'rgba(0, 0, 0, 0.4)',
  },
}));

const DealershipItem = ({ dealership, getDealershipEmployeesForCustomGroup }) => {
  const classes = useStyles();

  return (
    <Card className={classes.cardContent} onClick={() => getDealershipEmployeesForCustomGroup(dealership.id)}>
      <CardContent>
        <Typography className={classes.primaryText} gutterBottom>
          {dealership.name}
        </Typography>
        <div className={classes.cardBottom}>
          <span>{dealership.employeeCount || 0} employees</span>
          <span className={dealership.enabled ? '' : classes.secondaryTextRed}>
            {dealership.enabled ? 'Active' : 'Inactive'}
          </span>
        </div>
      </CardContent>
    </Card>
  );
};

export default function DealershipList({ dealerships = [], filteredArray = [], getDealershipEmployeesForCustomGroup }) {
  return dealerships.length ? (
    <Grid container>
      {filteredArray.map((dealership) => (
        <Grid item md={3} key={dealership.id}>
          <DealershipItem
            dealership={dealership}
            getDealershipEmployeesForCustomGroup={getDealershipEmployeesForCustomGroup}
          />
        </Grid>
      ))}
    </Grid>
  ) : null;
}
